/**
  * @param gmi - Gross monthly income
  * @return max front end debt
*/
const maxFrontEndDebt = (gmi) => {
    const mfeb = (gmi / 100) * 30
    return mfeb
}

/**
  * @param maxPurchasePrice - Calculated Max Purchase Price
  * @param taxRate - Tax rate from table based on town
  * @return max front end 
*/
const taxes = (maxPurchasePrice, taxRate) => {
  const txs = (maxPurchasePrice * taxRate) / 12
  return txs
}

/**
  * @param maxPurchasePrice - Calculated Max Purchase Price
  * @return Private Mortgage Insurance
*/
const privateMortgageInsurance = (maxPurchasePrice) => {
  const pmi = (maxPurchasePrice * 0.0085) / 12
  return pmi
}

/**
  * @param mpi - Calculated Max Principal & Interest 
  * @param rate - Interest Rate 
  * @return Max Purchase Price
*/
const maxPurchasePrice = (mpi, rate) => {
  if(rate === 0 )
    return mpi * 360;
  
  const p1 = Math.pow(1 + (rate / 12), 360) - 1
  const p2 = Math.pow(1 + (rate / 12), 360) * (rate / 12)
  const mpp = mpi * (p1 / p2)
  return mpp
}

/**
  * @param maxPurchasePrice - Calculated Max Purchase Price
  * @param homesteadEx - Homestead Exemption
  * @return  Taxed Value
*/
const taxedValue = (maxPurchasePrice, homesteadEx) => {
  const txValue = maxPurchasePrice - (maxPurchasePrice * homesteadEx)
  return txValue
}

/**
  * @param taxedValue - Calculated Taxed Value
  * @param taxRate - Tax rate from table based on town
  * @return Actual Monthly Taxes
*/
const actualMonthlyTaxes = (taxedValue, taxRate) => {
  const actualMonthlyTxes = (taxedValue * taxRate) / 12
  return actualMonthlyTxes
}

/**
  * @param taxes - Calculated taxes
  * @param actualMonthlyTaxes - Actual Monthly Taxes
  * @return Tax Relief Monthly
*/
const taxReliefMonthly = (taxes, actualMonthlyTaxes) => {
  const trm = taxes - actualMonthlyTaxes
  return trm
}

/**
  * @param taxes - Calculated taxes
  * @param homesteadEx - Homestead Exemption
  * @return Tax Relief Monthly
*/
const taxReliefMonthlyFlat = (taxes, homesteadEx) => {
  console.log(taxes, homesteadEx)
  const trm = taxes - homesteadEx
  return trm
}

/**
  * @param mpi - Calculated Max Principal & Interest
  * @param taxReliefMonthly - Caluclated Tax Relief Monthly
  * @return New Max Principal & Interest
*/
const newMaxPrincipalAndInterest = (mpi, taxReliefMonthly) => {
  const newMpi = mpi + taxReliefMonthly
  return newMpi
}

export {
    maxFrontEndDebt,
    taxes,
    privateMortgageInsurance,
    maxPurchasePrice,
    taxedValue,
    actualMonthlyTaxes,
    taxReliefMonthly,
    taxReliefMonthlyFlat,
    newMaxPrincipalAndInterest
}
